import { atom } from 'recoil'

import { createClaimApprovalLevelModalProps } from './types'

const defaultClaimApprovalLevelModal: createClaimApprovalLevelModalProps = {
  open: false,
  onSuccess: undefined,
  record: undefined,
}

const createClaimApprovalLevelModalAtom = atom({
  key: 'createClaimApprovalLevelModalAtom',
  default: defaultClaimApprovalLevelModal,
})

export default createClaimApprovalLevelModalAtom
